export default {
  home: '首页',
  company: {

    title: '关于公司',
    introduction:'公司介绍',
    structure:"下设机构",
    dream: '愿景和使命',
    events: '公司大事记',
    partners: '合作伙伴',
    honors: '荣誉资质',
    
  },
  applications: {
    title: '应用场景',
    magnetic: '磁体应用',
    nuclear: '可控核聚变',
    power: '超导电力'
  },
  products: {
    title: '产品与技术服务',
    tape: '第二代高温超导带材',
    performance: '带材性能介绍',
    advantages: '核心优势',
    service: '技术服务'
  },
  news: {
    title: '公司动态',
    company: '公司新闻',
    downloads: '资料下载'
  },
  recruit: '招聘',
  contact: {
    title: '联系我们',
    recruit: '招聘',
    postdoc: '博士后分站',
    info: '联系方式'
  }
}; 